import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
Vue.use(Router);

let routes = [
  {
    path: '/',
    redirect: '/pre-page'
  },
  {
    // 登录
    path: '/pre-page',
    name: 'pre-page',
    component: () => import('../views/pre-page.vue'),
    meta: { requiresAuth: false, title: '登录', deepth: 0, keepAlive: false }
  },
  {
    // AI
    path: '/ai',
    name: 'ai',
    component: () => import('../views/home/AI.vue'),
    meta: { requiresAuth: true, title: 'AI', deepth: 0, keepAlive: false }
  },
  {
    // 养旺圈
    path: '/ywq',
    name: 'ywq',
    component: () => import('../views/my/My.vue'),
    meta: { requiresAuth: true, title: '养旺圈', deepth: 0, keepAlive: true }
  },
  {
    // 养旺圈
    path: '/ywq-detail',
    name: 'ywq-detail',
    component: () => import('../views/my/Detail.vue'),
    meta: { requiresAuth: true, title: '详情', deepth: 1, keepAlive: false }
  },
  {
    // 养旺圈
    path: '/ywq-add',
    name: 'ywq-add',
    component: () => import('../views/my/Add.vue'),
    meta: { requiresAuth: true, title: '新增', deepth: 1, keepAlive: false }
  }
];

const routerContext = require.context('./', true, /index\.js$/);
routerContext.keys().forEach(route => {
  // 如果是根目录的 index.js 、不处理
  if (route.startsWith('./index')) {
    return;
  }
  const routerModule = routerContext(route);
  /**
   * 兼容 import export 和 require module.export 两种规范
   */
  routes = [...routes, ...(routerModule.default || routerModule)];
});

export default new Router({
  // base: '/webview',
  mode: 'hash',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    if (
      savedPosition &&
      to.meta.keepAlive &&
      store.state.keepAliveInclude.includes(to.name)
    ) {
      return savedPosition;
    }
    // 异步滚动操作
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
  }
});
